import { render, staticRenderFns } from "./PPPP.vue?vue&type=template&id=7358a529&scoped=true&"
var script = {}
import style0 from "./PPPP.vue?vue&type=style&index=0&id=7358a529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7358a529",
  null
  
)

export default component.exports